module.exports = __webpack_public_path__ + "static/media/bryanPicture.58dd253a.png";